import api from "./api";

export function getFinanceSupportPage(country_id) {
  return api.get(`/supportpage/${country_id}`);
}
